import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ScreenType } from 'src/app/enums/ScreenType';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import {
  patternValidator,
  passwordMatchValidator,
} from 'src/app/utils/password-util';
import { environment } from 'src/app/environments/environments';

@Component({
  selector: 'app-password-change-dialog',
  templateUrl: './password-change-dialog.component.html',
  styleUrls: ['./password-change-dialog.component.scss'],
})
export class PasswordChangeDialogComponent {
  hide = true;
  hideCnf = true;
  screenSize: ScreenType;
  ScreenType = ScreenType;
  isVerifying = false;
  baseServerURL = environment.apiUrl;
  constructor(
    private _formBuilder: FormBuilder,
    private screen: AumyeResponsiveScreenService,
    private http: HttpClient
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  createPwdFormGroup = this._formBuilder.group(
    {
      password: [
        '',
        [
          Validators.required,
          patternValidator(/\d/, {
            hasNumber: true,
          }),
          patternValidator(/[A-Z]/, {
            hasCapitalCase: true,
          }),
          patternValidator(/[a-z]/, {
            hasSmallCase: true,
          }),
          patternValidator(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/, {
            hasSpecialCharacters: true,
          }),
          Validators.minLength(8),
        ],
      ],
      confirmPassword: ['', [Validators.required]],
    },
    {
      validator: passwordMatchValidator,
    }
  );
  isPasswordVerified = false;
  isSamePassword = false;
  isUniquePassword = false;
  onVerifyPassword() {
    this.isVerifying = true;
    let baseServerURL = this.baseServerURL+'VerifyPasswordExists';
    this.http
      .post(baseServerURL, this.createPwdFormGroup.value, {
        responseType: 'text',
      })
      .subscribe((res: any) => {
        this.isVerifying = false;
        if (res === 'Password Unique') {
          this.isPasswordVerified = true;
          this.isUniquePassword = true;
        } else {
          this.isSamePassword = true;
          this.createPwdFormGroup.reset();
          setTimeout(() => {
            this.isSamePassword = false;
          }, 2500);
        }
      });
  }
}
